import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import "./plan-list.scss"
import Plan from "./plan/plan"
import NavArrow from "../shared/nav-arrow/nav-arrow"

const PlanList = ({
  plans,
  defaultPlanID,
  maximumToShow,
  onSelectPlan,
  planStyle,
  excludeVAT,
  entertainment,
  onAddEntertainment,
  pageToShowEntertainment,
  getPlanOptionWithName,
  storeName
}) => {
  const [visiblePlans, setVisiblePlans] = useState([])
  const [curPlanIndex, setCurPlanIndex] = useState(null)

  useEffect(() => {
    // Grab which plan to show in position 1
    const defaultPlanIndex = getPlanIndexFromID(defaultPlanID, plans)

    // Which plans we should currently be showing on the page
    setVisiblePlans(getVisiblePlans(plans, maximumToShow, defaultPlanIndex))
    setCurPlanIndex(defaultPlanIndex)
  }, [defaultPlanID, maximumToShow, plans])

  // Grab the subset of plans we should be showing
  function getVisiblePlans(allPlans, maxToShow, curIndex) {
    return allPlans.length === maxToShow
      ? allPlans
      : allPlans.slice(curIndex, curIndex + parseInt(maxToShow, 10))
  }

  // Grab the index of the default plan (so we can slice the plan array)
  function getPlanIndexFromID(planID, allPlans) {
    return allPlans.findIndex(plan => plan.id === planID)
  }

  // Shift the plans left (negative offset) or right (positive offset)
  function shiftPlans(offset, plans, maximumToShow) {
    // Grab the current plan index from the state
    let tmpPlanIndex = curPlanIndex

    // Shift the index, make sure we're not shooting over
    if (offset < 0 && curPlanIndex > 0) {
      --tmpPlanIndex
    } else if (offset > 0 && curPlanIndex < plans.length - maximumToShow) {
      ++tmpPlanIndex
    }
    // Update the state with the new index and the new plans
    if (tmpPlanIndex !== curPlanIndex) {
      setVisiblePlans(getVisiblePlans(plans, maximumToShow, tmpPlanIndex))
      setCurPlanIndex(tmpPlanIndex)
    }
  }

  return (
    <div className="plan-list">
      {false && plans.length > maximumToShow && (
        <NavArrow
          direction="left"
          active={curPlanIndex > 0}
          handleClick={() => shiftPlans(-1, plans, maximumToShow)}
        />
      )}
      <div className="plans">
        {visiblePlans.map(plan => {
          let entertainmentCost = entertainment[plan.id]
            ? entertainment[plan.id]
            : 0
          return (
            <Plan
              id={plan.id}
              data={plan.data}
              costs={plan.costs}
              benefits={plan.benefits}
              style={planStyle}
              onSelectPlan={onSelectPlan}
              key={plan.id}
              excludeVAT={excludeVAT}
              maximumToShow={maximumToShow}
              entertainment={entertainmentCost}
              pageToShowEntertainment={pageToShowEntertainment}
              onAddEntertainment={entertainmentCost => {
                onAddEntertainment(entertainmentCost, plan.id)
              }}
              getPlanOptionWithName={getPlanOptionWithName}
              storeName={storeName}
            />
          )
        })}
      </div>
      {false && plans.length > maximumToShow && (
        <NavArrow
          direction="right"
          active={curPlanIndex < plans.length - maximumToShow}
          handleClick={() => shiftPlans(1, plans, maximumToShow)}
        />
      )}
    </div>
  )
}

PlanList.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      data: PropTypes.object,
      costs: PropTypes.object,
      benefits: PropTypes.object,
      onSelectPlan: PropTypes.func
    })
  ).isRequired,
  planStyle: PropTypes.string.isRequired, // A String to describe the styling for the plan data
  defaultPlanID: PropTypes.string.isRequired, // Which plan to show in position 1
  onSelectPlan: PropTypes.func.isRequired, // A function that should be called with the PlanID of the selected plan
  maximumToShow: PropTypes.string, // Maximum number of plans to show before displaying next/prev buttons - there must be a better name for this
  excludeVAT: PropTypes.bool,
  getPlanOptionWithName: PropTypes.func
}

PlanList.defaultProps = {
  excludeVAT: false
}

export default PlanList
